<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-fullscreen-exit`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M34 16a2 2 0 01-2-2V5a1 1 0 011-1h2a1 1 0 011 1v7h7a1 1 0 011 1v2a1 1 0 01-1 1h-9zM14 32a2 2 0 012 2v9a1 1 0 01-1 1h-2a1 1 0 01-1-1v-7H5a1 1 0 01-1-1v-2a1 1 0 011-1h9zm18 2a2 2 0 012-2h9a1 1 0 011 1v2a1 1 0 01-1 1h-7v7a1 1 0 01-1 1h-2a1 1 0 01-1-1v-9zM16 14a2 2 0 01-2 2H5a1 1 0 01-1-1v-2a1 1 0 011-1h7V5a1 1 0 011-1h2a1 1 0 011 1v9z"/></svg>
</template>
<script>

export default {
  name: 'IconFullscreenExit',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
